import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-money",
  "use": "icon-money-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-money\"><defs><style type=\"text/css\"></style></defs><path d=\"M887.112 0L612.575 467.036h216.36v103.237H576.831v142.211h252.007v104.473H576.832V1024H447.168V816.957H185.845V712.484h261.323V570.273H185.845V467.036h222.918L136.888 0h146.204c127.002 231.95 204.192 379.01 231.57 441.274h2.661c9.221-25.571 34.603-77.19 76.05-154.76L748.797 0h138.314z\" p-id=\"2652\" fill=\"#0099FF\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/money.svg
// module id = ig9B
// module chunks = 81